module.exports = __webpack_public_path__ + "static/sec8-bg-sm-474d31681bd73511890eba9d9fae2e7f.jpg";